module.exports = __webpack_public_path__ + "4ab182d6218d4d6e1d6aced23a7f1661.svg";